<template>
  <button
    v-bind="$attrs"
    :type="type"
    class="font-base flex shrink-0 items-center justify-center rounded-sm p-5 transition-all focus:outline-none"
    :class="{
      'h-12 px-6 text-lg': size === 'xl',
      'px-5 py-3 text-lg': size === 'md',
      'border-4 border-transparent bg-primary text-secondary ':
        variant === 'primary',
      'border-2 border-primary text-primary': variant === 'secondary',
      'active:text-grey-900 border-2 border-transparent text-primary outline-none transition-all focus:outline-none active:border-transparent':
        variant === 'text',
    }"
  >
    <div class="flex flex-row items-center gap-2">
      <component :is="prefixIcon" /><slot /><component
        :is="suffixIcon"
        class="flex h-5 w-5"
      />
    </div>
  </button>
</template>

<script setup>
defineProps({
  size: {
    type: String,
    default: "md",
  },
  variant: {
    type: String,
    default: "text",
  },
  prefixIcon: {
    type: Function,
    default: () => null,
  },
  suffixIcon: {
    type: Function,
    default: () => null,
  },
  type: {
    type: String,
    default: "button",
  },
});
</script>
